module.exports = __webpack_public_path__ + "media/images/client-15-e9568d5b5b3cac090f4c5eeccb4e5de8.png";